import { Component, OnInit } from "@angular/core";
import { AdminService } from "src/app/services/admin.service";
import { apiUrl } from "src/app/global/global";
import { ActivatedRoute, Router } from "@angular/router";
import { ImageUrls } from "src/app/services/s3buket";
import { JobApplyService } from "src/app/jobseeker-component/job-apply/service/job-apply.service";
import { HttpParams } from "@angular/common/http";

@Component({
  selector: "app-jobs",
  templateUrl: "./jobs.component.html",
  styleUrls: ["./jobs.component.css"]
})
export class EmployerJobsComponent implements OnInit {

  employerID: any;
  jobsList: any = [];
  jobID?: string;
  jobDetailsData: any;
  recruiterImagePath = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;
  modalScrollDistance = 2;
  modalScrollThrottle = 50;
  limit = 5;
  skip = 1;
  totalCount: any;

  constructor(private api: AdminService, private route: ActivatedRoute,
    private router: Router, private jobApplyService: JobApplyService) {
    this.employerID = this.route.parent?.snapshot.paramMap.get("id") || "";
    if (this.employerID)
      this.getEmployerJobs();
  }

  ngOnInit(): void { }

  getEmployerJobs() {
    let params = new HttpParams();
    params = params.append("skip", this.skip.toString());
    params = params.append("limit", this.limit.toString());
    this.api.getData(apiUrl._employerPostedJobs + "/" + this.employerID, params).subscribe((res) => {
      this.jobsList = res.data.JobPost;
      this.totalCount = res.data.count;
      this.goToJobDetail(this.jobsList[0].id);
    });
  }

  onJobSaved(job: any) {
    job.saveStatus = job.saveStatus == 1 ? 0 : 1;
  }

  goToJobDetail(jobId: string) {
    this.jobID = jobId;
    // this.router.navigate(["employer-choice/details/" + this.employerID + "/jobs"], { queryParams: { id: jobId } });
    this.getJobDetail();
  }

  getJobDetail() {
    this.api.getData(apiUrl._getJobDetail + "/" + this.jobID, "").subscribe(async (res) => {
      this.jobDetailsData = res.data;
    }, err => { console.log(err.error.message, "errr") })
  }

  applyJob(jobId: string) {
    this.jobApplyService.openScreeningQuestionModal(jobId);
  }

  withdrawJob(jobId: string) {
    this.jobApplyService.withdrawJob(jobId);
  }

  public saveUnsaveJob(job: any, sectionType: number) {
    if (job.saveStatus == 0) {
      this.api.postData(apiUrl._saveUnsaveJob, { "jobPostId": job.id }).subscribe((res) => {
        if (sectionType == 2) {
          var findJobRef = this.jobsList.find((x) => x.id == this.jobID);
          if (findJobRef) findJobRef.saveStatus = 1;
        }
        if (job.id == this.jobDetailsData.JobPost.id)
          this.jobDetailsData.JobPost.saveStatus = 1;
        job.saveStatus = 1;
      });
    } else {
      this.api.deleteData(apiUrl._saveUnsaveJob, { "jobPostId": job.id }).subscribe((res) => {
        if (sectionType == 2)
          if (sectionType == 2) {
            var findJobRef = this.jobsList.find((x) => x.id == this.jobID);
            if (findJobRef) findJobRef.saveStatus = 0;
          }
        if (job.id == this.jobDetailsData.JobPost.id)
          this.jobDetailsData.JobPost.saveStatus = 0;
        job.saveStatus = 0;
      });
    }
  }

  jobSalary(job: any): string {
    let salary = "";
    if (job.price) salary = job.price + "/";
    else if (job.maximum && job.minimum) salary = job.minimum + "-$" + job.maximum + "/";
    else salary = job.minimum + job.maximum;
    if (job.rate)
      return "$" + salary + "" + job.rate.split(" ")[1];
    else
      return "$" + salary;
  }

  /** Infinite Scroll */
  onScrollDown() {
    console.log("scrolled down!!");
  }
  onModalScrollDown() {
    this.limit = this.totalCount;
    this.getEmployerJobs();
  }

  dateInMilisecond(date) {
    const d1 = new Date(date)
    const miliSecond = d1.getTime();
    return miliSecond
  }
}
